export default {
    namespaced: true,
    state: {
        categories: [],
        supplierCategories: []
    },
    getters: {
        categories(state) {
            return state.categories
        },
        nameCategory: state => id => {
            const category = state.categories.find(el => {
                if (el.CategoryID === id * 1) {
                    return el
                }
            })
            if (category) return category.Name
            return ''
        },
        //values for supplier products page filter, default all
        supplierCategoriesValuesArr(state) {
            return state.supplierCategories.map(category => category.CategoryID)
        }
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories
        },
        SET_SUPPLIER_CATEGORIES(state, categories) {
            state.supplierCategories = categories
        }
    },
    actions: {
        async getCategories({ commit }, data) {
            const categories = await this.$axios
                .get('/public/dict/categories', {
                    params: data
                })
                .then(res => {
                    return res.data
                })

            if (data && data.existing) {
                commit('SET_SUPPLIER_CATEGORIES', categories)
            } else {
                commit('SET_CATEGORIES', categories)
            }
        }
    }
}
